export const CheckboxInputStyles = {
  label: 'font-bold text-16px text-gray150 tracking-wide ml-1',
  field: 'text-16px text-black py-2 px-3'
}
